<template>
  <div class="login_page">
    <div class="container flex2 trans">
      <img src="../img/1_03.png" class="img1" />
      <div style="margin-top: 121px">
        <div class="title_1" style="white-space: nowrap">
          莲藕医生（药店端）
        </div>
        <div class="title_english">Lotus Root Healthy Pharmacy</div>

        <div class="flex22 tab_item_login_login">
          <div
            :class="
              tabIndex == item.status
                ? 'tab_item_login_1 avtive_title2'
                : 'tab_item_login_1'
            "
            v-for="(item, index) in tabList"
            :key="item.title"
            @click="changeTab(item.status, index)"
          >
            {{ item.title }}
            <div
              class="b-style"
              :class="tabIndex == item.status ? ' active-bg' : ''"
            ></div>
          </div>
        </div>
        <div v-if="tabIndex == 0" class="fixed-size">
          <div class="sweep-code">
            <img v-if="QRCodeUrl && QRCodeUrl.length > 0" :src="QRCodeUrl" />
            <span v-else></span>
          </div>
          <div class="font-color">请使用【莲藕健康APP】扫描二维码登录</div>
        </div>
        <div v-if="tabIndex == 1" class="fixed-size">
          <div class="flex2 input_container top-margin">
            <img src="../img/1_06.png" class="img_2" />
            <input
              type="text"
              class="input_mobile"
              placeholder="请输入登录手机号"
              maxlength="11"
              v-model="mobile"
              @keyup="enter13($event)"
            />
          </div>
          <div class="flex2 input_container">
            <img src="../img/password.png" class="img_2" />
            <input
              type="password"
              class="input_password"
              placeholder="请输入密码"
              v-model="password"
              @keyup="enter13($event)"
            />
          </div>
          <div class="flex2 input_container">
            <img src="../img/1_10.png" class="img_2" />
            <input
              type="text"
              class="input_password"
              placeholder="请输入验证码"
              maxlength="6"
              v-model="code"
              @keyup="enter13($event)"
            />
            <div class="get_code_text" @click="getCode">
              <img :src="codeUrl" width="80" alt="" />
              <div class="get_code_text_tip">看不清？换一张</div>
            </div>
          </div>
          <div class="login_btn" @click="login">登录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  DoctorPcLogin,
  GetQrCode,
  GetQrCodeLoginStatus,
  GetValidationCode,
} from "@/utils/api.js";
import {
  getCookie,
  setCookie,
  getAesStringNew,
  jieming,
} from "@/utils/common.js";
import { request } from "http";
export default {
  data() {
    return {
      codeUrl: "",
      getCodeText: "获取验证码",
      QRCodeUrl: "",
      mobile: "",
      password: "",
      code: "",
      tabIndex: 0,
      getCodeIng: false,
      loginIng: false,
      qrCode: "",
      timer: null,
      timerFive: null,
      tabList: [
        {
          title: "APP扫码登录",
          status: 0,
        },
        {
          title: "密码登录",
          status: 1,
        },
      ],
    };
  },
  methods: {
    //获取验证码
    getValidation() {
      GetValidationCode({}).then((res) => {
        if (res.code) {
          this.codeUrl = "data:image/jpg;base64," + res.data;
        }
      });
    },
    changeTab(status, i) {
      this.tabIndex = status;
      if (status == 0) {
        this.ajaxQrCode();
      } else {
        this.getValidation();
        clearInterval(this.timer);
      }
    },
    getCode() {
      this.getValidation();
      // if (this.getCodeText != "获取验证码") return;
      // if (this.getCodeIng) return;
      // if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
      //   this.$Message.error("手机号码输入有误");
      //   return false;
      // }
      // this.getCodeIng = true;
      // const msg = this.$Message.loading({
      //   content: "发送中",
      //   duration: 0,
      // });
      // var parsm = {
      //   mobile: this.mobile,
      //   uniqueId: "",
      // };
      // SendVaildCode(parsm)
      //   .then((res) => {
      //     setTimeout(msg, 17);
      //     if (res.code == 1) {
      //       this.$Message.success("验证码已发送");
      //       let count = 60;
      //       let that = this;
      //       let timer = setInterval(function () {
      //         count--;
      //         that.getCodeText = count + "s";
      //         if (count == -1) {
      //           that.getCodeText = "获取验证码";
      //           clearInterval(timer);
      //         }
      //       }, 1000);
      //       if (res.errmsg) {
      //         this.$Message.error(res.errmsg);
      //       }
      //       this.getCodeIng = false;
      //     } else {
      //       this.$Message.error(res.errmsg);
      //       this.getCodeIng = false;
      //     }
      //   })
      //   .catch((err) => {
      //     setTimeout(msg, 17);
      //     this.$Message.error("服务器出错啦，请稍候再试");
      //     this.getCodeIng = false;
      //   });
    },
    //回车事件
    enter13(ev) {
      if (ev.keyCode == 13) {
        this.login();
      }
    },
    //获取uninappind
    getuniaooid() {
      return new Promise((resolve, reject) => {
        let murmur;
        this.$Fingerprint.get((components) => {
          const values = components.map((component, index) => {
            if (index === 0) {
              //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
              return component.value.replace(/\bNetType\/\w+\b/, "");
            }
            return component.value;
          });
          // 生成最终id murmur
          murmur = this.$Fingerprint.x64hash128(values.join(""), 31);
          resolve(murmur);
        });
      });
    },
    async login() {
      if (this.loginIng) return;
      if (!this.mobile) {
        this.$Message.error("请输入手机号码");
        return;
      }
      if (!this.password) {
        this.$Message.error("请输入密码");
        return;
      }
      if (!this.code) {
        this.$Message.error("请输入验证码");
        return;
      }
      this.loginIng = true;
      let data = {
        Phone: this.mobile,
        Password: getAesStringNew(this.password),
        Graphics: this.code,
      };
      const msg = this.$Message.loading({
        content: "登陆中",
        duration: 0,
      });
      DoctorPcLogin(data)
        .then((res) => {
          this.loginIng = false;
          setTimeout(msg, 17);
          if (res.code == 1) {
            setCookie("access_token", res.data.AppToken, "h12");
            setCookie("mobile", res.data.MobilePhone, "h12");
            setCookie("uniqueId", res.data.UniqueId, "h12");
            setCookie("UserId", res.data.UserId, "h12");
            setCookie("OpenId", res.data.OpenId, "h12");
            setCookie("AdminId", res.data.AdminId, "h12");
            localStorage.setItem("hToken", res.data.AppToken);
            if (!res.data.ShopUser) {
              this.$Modal.info({
                title: "莲藕医生（药店端）",
                content: "您还没有在莲藕健康app中关联店铺！",
              });
              clearInterval(this.timer);
              this.ajaxQrCode();
              return false;
            }
            setCookie("ShopId", res.data.ShopUser.ShopId, "h12");
            localStorage.setItem("companyName", res.data.ShopUser.ShopName);
            localStorage.setItem("extendType", res.data.ShopUser.ShopType);
            this.$router.push({ path: "/index" });
            clearInterval(this.timer);
            // setCookie("access_token", res.Data.access_token, "h12");
            // setCookie("mobile", this.mobile, "h12");
            // this.$router.push({ path: "/index" });
            // this.$Message.error(res.errmsg);
          } else {
            this.$Message.error(res.msg);
            this.getValidation();
          }
        })
        .catch((err) => {
          setTimeout(msg, 17);
          this.$Message.error(err);
          this.loginIng = false;
        });
    },
    //获取登录二维码
    ajaxQrCode() {
      var parme = {
        source: 1,
        uniqueId: "",
      };
      // AAAAAElFTkSuQmCC
      GetQrCode(parme).then((res) => {
        if (res.code == 1) {
          this.QRCodeUrl = "data:image/png;base64," + res.data.CodeContent;
          this.QRCode = res.data.Code;
          clearInterval(this.timer);
          this.timer = setInterval(this.loginStatus, 2000);
        }
      });
    },
    //轮询qrcode
    loginStatus() {
      GetQrCodeLoginStatus({
        qrCode: this.QRCode,
        uniqueId: "",
      }).then((res) => {
        if (res.code == 1) {
          if (res.data != null) {
            setCookie("access_token", res.data.AppToken, "h12");
            setCookie("mobile", res.data.MobilePhone, "h12");
            setCookie("uniqueId", res.data.UniqueId, "h12");
            setCookie("UserId", res.data.UserId, "h12");
            setCookie("OpenId", res.data.OpenId, "h12");
            setCookie("AdminId", res.data.AdminId, "h12");
            localStorage.setItem("hToken", res.data.AppToken);
            if (!res.data.ShopUser) {
              this.$Modal.info({
                title: "莲藕医生（药店端）",
                content: "您还没有在莲藕健康app中关联店铺！",
              });
              clearInterval(this.timer);
              this.ajaxQrCode();
              return false;
            }
            setCookie("ShopId", res.data.ShopUser.ShopId, "h12");
            localStorage.setItem("companyName", res.data.ShopUser.ShopName);
            localStorage.setItem("extendType", res.data.ShopUser.ShopType);
            this.$router.push({ path: "/index" });
          }
        }
      });
    },
    // SgT6K4UOamDfmGtjlE0G1t9x8wCA1FOj9tj4Q6CVro7SY2YxV6iKaP7YgWn87T0ZdBIeVw6MfsE=
  },
  mounted() {
    // let _this = this;
    // document.onkeydown = function(e) {
    //   if (e.keyCode === 13) {
    //     _this.login(); //这里调用的是点击按钮登录的事件
    //   }
    // };
  },
  created() {
    this.ajaxQrCode();
    this.timerFive = setInterval((res) => {
      clearInterval(this.timer);
      this.ajaxQrCode();
    }, 240000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timerFive);
  },
};
</script>
<style lang="scss" scoped>
.sweep-code {
  // padding-top: 35px;
  padding-bottom: 20px;
  span {
    display: inline-block;
    background: #f3f3f3;
    width: 193px;
    height: 193px;
  }
  img {
    width: 193px;
    height: 193px;
  }
}
.font-color {
  color: #a9a9a9;
  font-size: 20px;
}
.b-style {
  width: 28px;
  height: 4px;
  position: absolute;
  left: 35%;
}
.fixed-size {
  width: 394px;
  height: 383px;
}
.fixed-size {
  margin-top: 20px;
}
.flex22 {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tab_item_login_1 {
  font-size: 24px;
  font-weight: bold;
  font-family: Microsoft YaHei;
  color: #333333;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}
.avtive_title2 {
  color: #2f318b;
}
.active-bg {
  background: #2f318b;
}
.get_code_text_tip {
  font-size: 12px;
  text-align: center;
  color: #2c3e50;
  font-weight: 400;
}
</style>
<style lang="scss" scoped src="../scss/login.scss">
</style>